import React, { useState, useEffect, useMemo, useRef } from 'react';
import styles from './LoadingIndicator.module.css';

const LoadingIndicator = ({ text }) => {
  const [dots, setDots] = useState(0);
  const intervalIdRef = useRef(null);

  const checkAndRemoveEllipsis = useMemo(() => {
    return (str) => {
      if (typeof str === 'string' && str.endsWith('...')) {
        str = str.replace('...', '');
      }
      return str;
    };
  }, []);

  const updateDots = () => {
    setDots((dots) => (dots + 1) % 4);
  };

  useEffect(() => {
    intervalIdRef.current = setInterval(updateDots, 500);

    return () => clearInterval(intervalIdRef.current);
  }, []);

  return (
    <div className={styles.container} aria-label="Loading">
      {checkAndRemoveEllipsis(text)}
      <div className={styles.ellipsis} style={{ width: '15px' }}>
        {'.'.repeat(dots)}
      </div>
    </div>
  );
};

export default LoadingIndicator;
